module.exports = __webpack_public_path__ + "img/立体图标 拷贝 12.367b78ec.png";